<template lang="pug">

  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-md-6
        .ibox.float-e-margins
          .ibox-title
            h2 {{ user.username }} ({{ user.role_name }})

          .ibox-content
            .row
              .col-xs-12
                form(role="form" v-on:submit.prevent="onSubmit")
                  .bg-danger.p-xs.b-r-sm(v-show="failText") {{ failText }}
                  .form-group
                    label Password
                    input.form-control(type="password" placeholder="New Password" v-model="user.password" @blur="onPassChange" required)
                  .form-group
                    label Re-Password
                    input.form-control(type="password" placeholder="Re-Password" v-model="user.repassword" @blur="onPassChange" required)
                  div
                    button.btn.btn-sm.btn-primary.m-t-n-xs(type="submit" :disabled="!isPassMatch")
                      strong(v-if="userId") Save
                      strong(v-else) Create
                    | &nbsp;&nbsp;&nbsp;
                    button.btn.btn-sm.btn-white.m-t-n-xs(@click="$router.go(-1)")
                      strong Cancel

</template>

<script>
  import axios from 'axios'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'

  export default {
    data () {
      return {
        userId: this.$route.params.id,
        user: {},
        isPassMatch: false,
        failText: ''
      }
    },
    created () {
      this.fetchUser()
    },
    methods: {
      fetchUser () {
        axios.get(`user/id/${this.userId}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.user = res.data.data
              this.user.update_by_id = this.$ls.get('user').id
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      onPassChange () {
        if (this.user.password && this.user.repassword) {
          if (this.user.password === this.user.repassword) {
            this.isPassMatch = true
            this.failText = ''
          } else {
            this.isPassMatch = false
            this.failText = `Password don't match`
          }
        }
      },
      onSubmit () {
        axios.put('user/changepass', this.user).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              toastr.success(`Success to change password`, { timeOut: 2000 })
              this.$router.push('/users')
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              toastr.error('Change Fail', res.data.message, { timeOut: 2000 })
              this.$router.push('/users')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// repass.vue?1957735d